import * as React from 'react';

// Hooks
import { useTranslation, config } from '@shopee-user/platform';

// Components
import { InputPhone } from '@shopee-user/input';

// Types
import { InputProps } from '@shopee-user/input';

export default function SignupInputAuthKey(field: InputProps) {
  const I18n = useTranslation();
  return (
    <InputPhone
      {...field}
      placeholder={I18n.t('label_auth_phone_number_placeholder', {
        context: config.LOCALE.toLocaleLowerCase(),
      })}
      showErrorOutline
      showError
      autoFocus
    />
  );
}
